var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.04 22.667h3.534c.27 0 .326.112.326.432v7.141h2.864v-.373-8.342a21.988 21.988 0 00-.22-3.28c-.31-2.527-1.3-4.96-2.895-7.109a.5.5 0 00-.196-.184.616.616 0 00-.28-.072h-6.016v19.317h2.864l.018-7.53zm0-7.712c0-.448 0-.448.35-.448h2.068c.068.01.131.034.186.069a.389.389 0 01.128.133 9.23 9.23 0 011.109 4.118.341.341 0 010 .122h-3.823v-4.016l-.019.022zM10.91 22.635h3.54V18.98H10.93v-4.474h4.324c.213 0 .282-.075.276-.358v-2.97-.299H8.034v19.317h2.876v-7.562zM33.377 30.192h2.876V14.496h2.707v-3.61h-8.297V14.5h2.714v15.691zM19.502 10.885H16.65v19.328h2.852V10.885z"
  })));
}
export default SvgFiat;